<template>
  <div
    v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('view_apartment')"
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <!-- Search container -->
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('search.title')"
                  v-model="search.searchText"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success"
                  @click="onSearchCase"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <div class="">
          <div class="panel with-nav-tabs panel-primary">
            <div class="panel-heading">
              <ul class="nav nav-tabs">
                <li class="active" @click="onSelectTab(apartmentTypeTabs.APARTMENT_TYPE)">
                  <a href="#tab1primary" data-toggle="tab">{{
                    $t("apartmentType.title")
                  }}</a>
                </li>
                <li @click="onSelectTab(apartmentTypeTabs.APARTMENT_GROUP)">
                  <a href="#tab2primary" data-toggle="tab">{{
                    $t("apartmentGroup.title")
                  }}</a>
                </li>
                <li @click="onSelectTab(apartmentTypeTabs.PRODUCT_IN_APARTMENT_TYPE)">
                  <a href="#tab3primary" data-toggle="tab">{{
                    $t("product.productTitle")
                  }}</a>
                </li>
              </ul>
            </div>
            <div class="panel-body">
              <div class="tab-content">
                <div class="tab-pane fade in active" id="tab1primary">
                  <apartment-type-list ref="apartmentTypeList"></apartment-type-list>
                </div>
                <div class="tab-pane fade" id="tab2primary">
                  <apartment-group ref="apartmentGroup"></apartment-group>
                </div>
                <div class="tab-pane fade" id="tab3primary">
                  <product-in-apartment-type ref="productInApartmentType"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <!-- </div>
        </div> -->
        <!--  -->
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
// import LTEButton from "@/components/LTEButton.vue";
// import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from '@/lib/utils';
// import moment from "moment";
import Loading from "vue-loading-overlay";
import Enum from "../../../enum/enum";
import ApartmentTypeList from "./ApartmentTypeList";
import ApartmentGroup from "./ApartmentGroup"
import ProductInApartmentType from "./ProductInApartmentType"

export default {
  name: "CaseList",
  data() {
    return {
      search: {
        searchText: null
      },
      isLoading: false,
      apartmentTypeTabs: Enum.ApartmentTypeTabs,
      tabSelect: Enum.ApartmentTypeTabs.APARTMENT_TYPE
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA"
    ])
  },

  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onSelectTab: function(value){
      this.tabSelect = value
      switch (value) {
        case 0:
          this.$refs.apartmentTypeList.getSearchData(this.search.searchText)
          break;
        case 1:
          this.$refs.apartmentGroup.getSearchData(this.search.searchText)
          break;
        case 2:
          this.$refs.productInApartmentType.getSearchData()
          break
        default:
          break;
      }
    },
    onSearchCase: function() {
      if (this.tabSelect === Enum.ApartmentTypeTabs.APARTMENT_TYPE){
        this.$refs.apartmentTypeList.getSearchData(this.search.searchText)
      }
      if (this.tabSelect === Enum.ApartmentTypeTabs.APARTMENT_GROUP) {
        this.$refs.apartmentGroup.getSearchData(this.search.searchText)
      }
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST"
    ])
  },
  mounted() {
  },

  components: {
    // "lte-button": LTEButton,
    // "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    ApartmentTypeList,
    ApartmentGroup,
    ProductInApartmentType
  }
};
</script>
<style scoped>
.panel.with-nav-tabs .panel-heading {
  padding: 5px 5px 0 5px;
}
.panel.with-nav-tabs .nav-tabs {
  border-bottom: none;
}
.panel.with-nav-tabs .nav-justified {
  margin-bottom: -1px;
}
/********************************************************************/
/*** PANEL PRIMARY ***/
.with-nav-tabs.panel-primary .nav-tabs > li > a,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
}
.with-nav-tabs.panel-primary .nav-tabs > .open > a,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:focus,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
  background-color: #3071a9;
  border-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.active > a,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:focus {
  color: #428bca;
  background-color: #fff;
  border-color: #428bca;
  border-bottom-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu {
  background-color: #428bca;
  border-color: #3071a9;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu > li > a {
  color: #fff;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:focus {
  background-color: #3071a9;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:focus {
  background-color: #4a9fe9;
}
</style>



// WEBPACK FOOTER //
// src/views/ApartmentType/ApartmentTypeAndApartmentGroup.vue